import * as React from 'react';
import { toast } from 'react-toastify';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import { getFilter, setFilter } from '../Common/Utilities';

export default class VendorsReport extends React.Component {
	constructor() {
		super();

		const persisted = getFilter(["Reports", "VendorsReport"]) || {};

		this.state = {
			data: [],
			filterText: persisted.filterText ?? '',
			filterModel: persisted.filterModel || { items: [] },
			columnVisibility: persisted.columnVisibility ?? {},
			sortModel: persisted.sortModel || []
		};
		this.mainGridRef = React.createRef();
	}

	componentDidMount() {

		const gridRef = this.mainGridRef.current;
		const { filterModel, filterText } = this.state;

		gridRef.setFilterModel({
			...filterModel,
			quickFilterValues: ['']
		});
		if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {
			gridRef.setQuickFilterValues([filterText]);
		}
		this.fetchVendors();
	}

	fetchVendors() {
		var that = this;

		this.props.inProgress(true);

		httpGet('/api/reports/vendors')
			.then((response) => {
				//var data = response.data;
				var data = (response.data || []).map((e, i) => { let d = { ...e, rowId: i }; return d });
				that.setState({ data: data });

				this.props.inProgress(false);
			})
			.catch((error) => {
				this.props.inProgress(false);
				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
			});
	}

	render() {
		return (
			<div>
				<h1>Vendors</h1>
				<div className="form-group">
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={this.state.data}
							disableColumnMenu
							pagination
							pageSize={10}
							gridRef={this.mainGridRef}
							columns={[
								{
									headerName: 'Site ID',
									field: 'siteId',
									flex:0.4
								},
								{
									headerName: 'Code',
									field: 'vendorCode',
									flex: 0.5, hideable: false
								},
								{
									headerName: 'Name',
									field: 'vendorName',
									width: 300,
									flex: 1, hideable: false
								},
								{
									headerName: 'Short Name',
									field: 'shortName',
									width: 300,
									flex: 1,
									renderCell:(props )=>props.row.vendorName
								},
								{
									headerName: 'Vendor Address',
									field: 'vendorAddress',
									width: 500,
									flex: 1
								}
								
							]}
							setFilterText={(text) => {
								this.setState({ filterText: text });
								setFilter(["Reports", "VendorsReport", "filterText"],text )
							}}
							highlightSearchTextOnMainScreenGrid={true}
							onColumnVisbilityModelChange={(model) => {
								this.setState({ columnVisibility: model });
								setFilter(['Reports', 'VendorsReport', 'columnVisibility'], model)
							}}
							columnVisibilityModel={this.state.columnVisibility}
							onSortModelChange={(model) => {
								this.setState({ sortModel: model });
								setFilter(['Reports', 'VendorsReport', 'sortModel'], model);
							}}
							sortModel={this.state.sortModel}
							onFilterModelChange={(newModel) => {
								this.setState({ filterModel: newModel });
								setFilter(['Reports', 'VendorsReport'], {
									...getFilter(['Reports', 'VendorsReport']),
									filterModel: newModel
								});
							}}
							options={{
								pageSize: 10,
								pageSizeOptions: [10, 20, 30, 40, 50],
								maxBodyHeight: 670,
								filtering: true,
								columnsButton: true,
								exportButton: true,
								exportAllData: true,
								exportFileName: "Vendors"
							}}
							getRowId={(row) => row.rowId}
							disableSelectionOnClick
						/>
					</div>
				</div>
			</div>
		);
	}
}
